import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Carousel, Button, Container, Row, Col, Accordion, Card } from 'react-bootstrap';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import './TexasModels.css';

import tmImg4 from '../../assets/TexasModelsPhotos/tmImg4.jpg'

const TexasModels = () => { 
  const [index, setIndex] = useState(0);
  const [texasRentals, setTexasRentals] = useState([]); // Dynamic state

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  const getSlug = (title) => {
    return title.toLowerCase()
      .replace(/[^a-z0-9]+/g, '-') // Changes everything that are not letters and numbers to slashes
      .replace(/(^-|-$)/g, '');    // Removes slashes on start and end
  };

  // Add fetch logic
  useEffect(() => {
    const fetchTexasProperties = async () => {
      try {
        //const response = await fetch('http://localhost:5000/api/properties/texas');
        const response = await fetch('/api/properties/texas');
        if (response.ok) {
          const data = await response.json();
          setTexasRentals(data);
        }
      } catch (error) {
        console.error("Error fetching Texas properties:", error);
      }
    };
    fetchTexasProperties();
  }, []);

  return (
    <div className="tm-page">
      {/* --- Section 1 ---------------------------------------------- */}
      <section className="tm-section">
        <div className="tm-carousel-progress-container">
          <div className="tm-carousel-progress-bar" key={index}></div>
        </div>

        <div className="tm-custom-caption-container">
          <Container>
            <Row>
              <Col md={7} lg={8} className="tm-text-start ps-4">
                <span className="tm-subtitle-top tm-animate-fade">BEST LOCATIONS.</span>
                <h1 className="tm-title tm-animate-fade">
                  Texas-Sized Living <br />
                  <span className="tm-highlight">Starts Here!</span>
                </h1>

                <Button 
                  as={Link} 
                  to="/contact-us" 
                  className="tm-explore-btn mt-4 tm-animate-fade"
                >
                  Inquire Now
                </Button>
              </Col>
            </Row>
          </Container>
        </div>

        <Carousel 
          activeIndex={index}
          onSelect={handleSelect}
          fade 
          controls={false} 
          indicators={true} 
          interval={10000} 
          pause={false}
          className="fm-carousel"
        >
          {[1, 2, 3].map((slideNum) => (
            <Carousel.Item key={slideNum}>
              <div className="tm-carousel-image-container">
                <div className={`tm-zoom-image tm-slide-${slideNum}`}></div>
                <div className="tm-overlay"></div>
              </div>
            </Carousel.Item>
          ))}
        </Carousel>
      </section>
      {/* --- Section 1 ---------------------------------------------- */}

      {/* --- Section 2------------------------------------------------*/}
        <section className="tm-why-choose-section">
            <Container>
            <Row className="align-items-center py-5">
                <Col lg={4} className="tm-text-start mb-4 mb-lg-0">
                <h2 className="tm-why-title">
                    WHY CHOOSE <br />
                    <span className="highlight-blue">Texas ?</span>
                </h2>
                </Col>
      
                <Col lg={8}>
                <Row className="text-center">
                    <Col md={4} className="mb-4 mb-md-0">
                    <div className="why-icon-box">
                        <i className="bi bi-briefcase icon-style"></i>
                        <p className="why-icon-text">The Texas Workforce Commission projects 
                            an 18.3% increase in Texas employment, more than double the 
                            projected growth for the nation - 7.7% from 2023 until 2030</p>
                    </div>
                    </Col>
      
                    <Col md={4} className="mb-4 mb-md-0">
                    <div className="tm-why-icon-box">
                        <i className="bi bi-wallet2 icon-style"></i>
                        <p className="why-icon-text">Texas has some of the lowest unemployment rates, 
                            it also offers low costs of living. Housing prices are 
                            usually lower than in other states. Food, Health Care, 
                            and Transportation is affordable.</p>
                    </div>
                    </Col>
      
                    <Col md={4}>
                    <div className="tm-why-icon-box">
                        <i className="bi bi-buildings icon-style"></i>
                        <p className="why-icon-text">Three of the Ten Largest Cities in the 
                            United States are in Texas. Dallas, Houston, 
                            and San Antonio.</p>
                    </div>
                    </Col>
                    </Row>
                  </Col>
                </Row>
              </Container>
        </section>
        {/* --- Section 2------------------------------------------------*/}

        {/* --- Section 3 -----------------------------------------------*/}
        <section className="tm-faq-section py-5 bg-white">
            <Container className="py-5">
            <Row>
                {/* left side */}
                <Col lg={5} className="text-start mb-5 mb-lg-0">
                <h2 className="tm-faq-main-title mb-4">FREQUENTLY ASKED <br /> QUESTIONS</h2>
                <div className="tm-faq-img-wrapper">
                    <img src={tmImg4} alt="FAQ" className="tm-img-fluid about-img" />
                    <div className="tm-faq-shadow-bg"></div>
                </div>
                </Col>

                {/* Right side */}
                <Col lg={7} className="ps-lg-5">
                <Accordion flush className="tm-custom-faq-accordion">
                    
                    {/* Question 1 */}
                    <Accordion.Item eventKey="0" className="mb-4 border-bottom">
                    <Accordion.Header>
                        Where Is Happy Dream Located?
                    </Accordion.Header>
                    <Accordion.Body>
                        We are located in Metrowest off the intersection of Kirkman 
                        Rd and Arnold Palmer Dr. Conveniently located just a few minutes 
                        from downtown Orlando, attractions, shopping centers, major roads I-4, 408, 
                        Turnpike, etc. Only 10 min from Mall at Millennia.
                    </Accordion.Body>
                    </Accordion.Item>

                    {/* Question 2 */}
                    <Accordion.Item eventKey="1" className=" mb-4 border-bottom">
                    <Accordion.Header>
                        How Can Happy Dream Services Help Protect My Investments?
                    </Accordion.Header>
                    <Accordion.Body>
                        We place your interests first, from the way we structure our 
                        reporting to the way our 24-hour service center is organized to 
                        provide you with immediate problem-solving and big-picture data. 
                        We maximize your assets’ value through efficiency and genuine 
                        care for your goals.
                    </Accordion.Body>
                    </Accordion.Item>

                    {/* Question 3 */}
                    <Accordion.Item eventKey="2" className="border-bottom">
                    <Accordion.Header>
                        What Is Your Tenant Relationship Philosophy?
                    </Accordion.Header>
                    <Accordion.Body>
                        We recognize that tenants are one of your building’s top assets. 
                        We empower our teams to create memorable tenant experiences that 
                        build your brand and benefit your bottom line. We’ll promote 
                        practices and programs that enhance the best relationships with 
                        tenants and increase business cooperation. By responding to 
                        building and tenant issues quickly and by maintaining brand reputation, 
                        we help maximize your investment.
                    </Accordion.Body>
                    </Accordion.Item>

                </Accordion>
                </Col>
            </Row>
            </Container>
        </section>
        {/* --- Section 3 ------------------------------------------------------- */}

        {/* --- Section 4---------------------------------------------------------*/}
        <section className="tm-rentals-section pt-5 pb-0">
          <Container>
            <h2 className="tm-rentals-main-title text-center mb-5">Our Texas Properties</h2> 
            
            <Swiper
              modules={[Pagination, Autoplay]}
              spaceBetween={30}
              slidesPerView={1}
              pagination={{ clickable: true }}
              autoplay={{ delay: 5000 }}
              breakpoints={{
                768: { slidesPerView: 2 },
                1024: { slidesPerView: 4 },
              }}
              className="pb-5"
            >
              {texasRentals.map((item) => {
              const mainImg = item.images && item.images.length > 0 
                //? `http://localhost:5000/uploads/${item.images[0].replace(/\\/g, '/').replace('uploads/', '')}`
                ? `/api/uploads/${item.images[0].replace(/\\/g, '/').replace('uploads/', '')}`
                : 'https://via.placeholder.com/400x300?text=Texas+Property';

              return (
                <SwiperSlide key={item.id}>
                  <Card className={`tm-rental-card h-100 border-0 ${!item.isAvailable ? 'tm-leased-card' : ''}`}>
                    <div className="tm-rental-img-container">
                      
                      {/* --- STATUS BADGE --- */}
                      <div className={`tm-property-status-tag ${item.isAvailable ? 'tm-status-available' : 'tm-status-leased'}`}>
                        {item.isAvailable ? 'AVAILABLE' : 'LEASED'}
                      </div>

                      <Card.Img 
                        variant="top" 
                        src={mainImg} 
                        className="tm-rental-img" 
                        style={{ filter: item.isAvailable ? 'none' : 'grayscale(60%) opacity(0.7)' }}
                      />

                      <div className="tm-rental-overlay">
                        <Link to={`/project/${getSlug(item.title)}`} className="tm-view-btn-overlay">
                          {item.isAvailable ? 'View Details' : 'View Property'}
                        </Link>
                      </div>
                    </div>

                    <Card.Body className="tm-text-start d-flex flex-column p-4">
                      <Card.Title className="tm-rental-unit-title d-flex justify-content-between align-items-center">
                        {item.title}
                        <span className={`tm-status-dot ${item.isAvailable ? 'bg-success' : 'bg-danger'}`}></span>
                      </Card.Title>
                      <Card.Text className="tm-rental-location-text mb-3">
                        <i className="bi bi-geo-alt-fill me-1"></i> {item.location}
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </SwiperSlide>
              );
            })}
            </Swiper>
          </Container>
        </section>
        {/* --- Section 4---------------------------------------------------------*/}
      </div>
  );
};

export default TexasModels;